module.exports = __webpack_public_path__ + "img/img_cmag4.d87abbbe.png";